import React, { Component } from "react";
import "./image-loader.css";

const IMG_SERVER = process.env.REACT_APP_CDN;

class ImageLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false
    };
  }

  render() {
    const { isError } = this.state;
    const { src, width, classImg, style } = this.props;
    let srcImg = '';
    const resizeWidth = `w${width ? width : 150}`;
    const isGif = str => RegExp(/\.gif$/i).test(str);

    if (src && !(src.includes("http://") || src.includes("https://"))) {
      srcImg = IMG_SERVER + resizeWidth + '/uploads/' + src;
    } else {
      if (src) {
        const w = src.split('/')[3];
        if(isGif(src)){
          const newWidth = `gif/${w}`;
          srcImg = src.replace(w, newWidth);
        } else {
          const newWidth = w.includes('w') ? resizeWidth : `${resizeWidth}/${w}`;
          srcImg = src.replace(w, newWidth);
        }
      }
    }

    return (

      <React.Fragment>
        {src &&
          <img
            src={`${srcImg}`}
            className={`lazyload image-loader${isError ? " d-none" : ''} ` + classImg}
            alt={this.props.alt}
            style={style}
            onError={() => {
              this.onError();
            }}
          />

        }
      </React.Fragment>
    );
  }

  onError() {
    this.setState({ isError: true });
    if (this.props.onError) {
      this.props.onError();
    }
  }
}

export default ImageLoader;
